import { render } from "./Categories.vue?vue&type=template&id=218feb8e"
import script from "./Categories.vue?vue&type=script&lang=js"
export * from "./Categories.vue?vue&type=script&lang=js"

import "./Categories.vue?vue&type=style&index=0&id=218feb8e&lang=scss"
script.render = render

export default script